import { Predicates } from "libraries/predicates/predicates";
import {
    ComponentType,
    ICompositionMpnComponent,
    IMpnComposition,
    ITccComposition,
} from "../../../../types/data.interface";
import { CompositionType } from "../mpn-composition-modal/AddMpnCompositionModal";
import { useCreateMpnStore } from "../../context/create/CreateMpnContext";
import TreeActionsGroup from "./TreeActionsGroup";
import { formatCodeLabel, formatMoldLabel } from "../../helpers/resolveMoldedMoldId";
import { CompositionCheckbox } from "../mpn-composition-modal";
import { Tooltip } from "react-tooltip";

type HighlightColumns = {
    mold: boolean;
    color: boolean;
    decorTech: boolean;
    artwork: boolean;
    material: boolean;
};

export type HighlightsCheckType = "restrictive" | "not-restrictive";

const ComponentsTable = ({
  skuId,
  isSummaryPage,
  isModal,
  isPipPage,
  components,
  componentsType,

  addActionHandler,
  handleRemoveNode,
  openEditModal,

  shouldIncludeSku,
  manageComponentInclusion,
  assertComponentIsIncluded,
  tccComposition,
  highlightsCheckType,
  setCompositionHasHighlights,
}: {
  skuId: string;
  isSummaryPage: boolean;
  isModal: boolean;
  isPipPage: boolean;
  // components: ICompositionComponent[];
  components?: any[];
  componentsType: ComponentType;

  addActionHandler?: (node_id: number, newQuantity: number) => void;
  handleRemoveNode?: (
    node_id: number,
    compositionType: CompositionType,
  ) => void;
  openEditModal?: (
    compositionEditType: CompositionType,
    compositionEditObject: ICompositionMpnComponent | IMpnComposition,
  ) => void;

  shouldIncludeSku: boolean;
  manageComponentInclusion: any;
  assertComponentIsIncluded: any;

  tccComposition: ITccComposition[];
  highlightsCheckType?: HighlightsCheckType;
  setCompositionHasHighlights?: () => void;
}) => {
  const { state, dispatch } = useCreateMpnStore();

  const shouldCompareWithItemNumberComposition: boolean =
    isSummaryPage && !isPipPage && tccComposition.length > 0;

  const compareComponentWithItemNumberComposition = (
    component: ICompositionMpnComponent,
  ): HighlightColumns => {
    if (shouldCompareWithItemNumberComposition) {
      let highlightColumns: HighlightColumns;
      switch (highlightsCheckType) {
        // NOTE: IS COMMENTS BECAUSE WE DON'T NEED TO CONCERN ABOUT THAT RIGHT NOW (01-NOV-2025)
        // case "restrictive":
        //   highlightColumns = restrictiveComparison(component);
        //   break;
        // case "not-restrictive":
        //   highlightColumns = notRestrictiveComparison(component);
        //   break;
        default:
          highlightColumns = {
            mold: false,
            color: false,
            decorTech: false,
            artwork: false,
            material: false,
          };
          break;
      }

      const atLeastOneHighlight = Object.values(highlightColumns).some(
        (value) => value,
      );
      if (
        Predicates.isNotNullAndNotUndefined(setCompositionHasHighlights) &&
        atLeastOneHighlight
      )
        setCompositionHasHighlights();

      return highlightColumns;
    } else {
      return {
        mold: false,
        color: false,
        decorTech: false,
        artwork: false,
        material: false,
      };
    }
  };


  // NOTE: IS COMMENTS BECAUSE WE DON'T NEED TO CONCERN ABOUT THAT RIGHT NOW (01-NOV-2025)
  // const restrictiveComparison = (
  //   component: ICompositionMpnComponent,
  // ): HighlightColumns => {
  //   const validTccCompositionRows: ITccComposition[] = tccComposition.filter(
  //     (compositionRow) =>
  //       (Predicates.isNotNullAndNotUndefined(compositionRow.mold) ||
  //         Predicates.isNotNullAndNotUndefined(compositionRow.nonMold)) &&
  //       Predicates.isNotNullAndNotUndefined(compositionRow.color),
  //   );
  //
  //   const componentHasMoldInValidRows: boolean = validTccCompositionRows
  //     .map((compositionRow) =>
  //       compositionRow.component_type === "Molded"
  //         ? compositionRow.mold?.id
  //         : compositionRow.nonMold?.id,
  //     )
  //     .filter(Predicates.isNotNullAndNotUndefined)
  //     .includes(String(component.mold_id));
  //
  //   const highlightColumns: HighlightColumns = {
  //     mold: false,
  //     color: true,
  //     decorTech: false,
  //     artwork: false,
  //     material: false,
  //   };

  //   if (validTccCompositionRows.length === 0 || !componentHasMoldInValidRows)
  //     return { mold: false, color: false, decorTech: false, artwork: false, material:false };
  //
  //   for (const tccCompositionRow of validTccCompositionRows) {
  //     if (
  //       tccCompositionRow.component_type === "Molded" &&
  //       tccCompositionRow.mold?.id === String(component.mold_id) &&
  //       tccCompositionRow.color?.id === component.color_id
  //     ) {
  //       highlightColumns.color = false;
  //     } else if (
  //       tccCompositionRow.component_type === "NonMolded" &&
  //       tccCompositionRow.nonMold?.id === String(component.mold_id) &&
  //       tccCompositionRow.color?.id === component.color_id
  //     ) {
  //       highlightColumns.color = false;
  //     }
  //   }
  //   return highlightColumns;
  // };

  // const notRestrictiveComparison = (
  //   component: ICompositionComponent,
  // ): HighlightColumns => {
  //   const tccCompositionMolds: IMold[] = tccComposition
  //     .map((composition) => composition.mold)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //   const tccCompositionNonMolds: IMold[] = tccComposition
  //     .map((composition) => composition.nonMold)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //   const tccCompositionColors: IColor[] = tccComposition
  //     .map((composition) => composition.color)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //   const tccCompositionDecor: IDecorationTech[] = tccComposition
  //     .map((composition) => composition.decorTech)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //   const tccCompositionArtworks: IDesign[] = tccComposition
  //     .map((composition) => composition.artwork)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //
  //   const highlightColumns: HighlightColumns = {
  //     mold: true,
  //     color: true,
  //     decorTech: true,
  //     artwork: true,
  //     material: true,
  //   };
  //
  //   for (const composition of tccComposition) {
  //     if (
  //       (component.type === "Molded" &&
  //         Predicates.isNotNullAndNotUndefined(composition.mold) &&
  //         composition.mold.id === String(component.mold_id)) ||
  //       (component.type === "NonMolded" &&
  //         Predicates.isNotNullAndNotUndefined(composition.nonMold) &&
  //         composition.nonMold.id === String(component.mold_id))
  //     ) {
  //       highlightColumns.mold = false;
  //     }
  //     if (
  //       tccCompositionColors.length === 0 ||
  //       (Predicates.isNotNullAndNotUndefined(composition.color) &&
  //         composition.color.id === component.color_id)
  //     ) {
  //       highlightColumns.color = false;
  //     }
  //     if (
  //       tccCompositionDecor.length === 0 ||
  //       String(component.decoration_technique_id) === "0" ||
  //       (Predicates.isNotNullAndNotUndefined(composition.decorTech) &&
  //         composition.decorTech.id ===
  //           String(component.decoration_technique_id))
  //     ) {
  //       highlightColumns.decorTech = false;
  //     }
  //     if (
  //       tccCompositionArtworks.length === 0 ||
  //       String(component.artwork_id) === "0" ||
  //       (Predicates.isNotNullAndNotUndefined(composition.artwork) &&
  //         composition.artwork.id === String(component.artwork_id) &&
  //         composition.artwork.deco_tech_id ===
  //           String(component.decoration_technique_id))
  //     ) {
  //       highlightColumns.artwork = false;
  //     }
  //   }
  //
  //   return highlightColumns;
  // };
  // END NOTE: IS COMMENTS BECAUSE WE DON'T NEED TO CONCERN ABOUT THAT RIGHT NOW (01-NOV-2025)


  // const formatDisplayComponent = (
  //   componentField: any,
  //   component: ICompositionMpnComponent,
  // ) => {
  //
  //   return "-";
  // };

  const pipPageAndModalComponents = (component:any, type = "Molded") => {

    const { mold, non_mold, ...rest } = component;

    if (type === "NonMolded") {
        const { id, name, sequence_number } = non_mold;

        const nonMold = {
            mold: !!sequence_number
                ? { id, description: `${sequence_number} - ${name}` }
                : {
                      id,
                      description: `${id} - ${name}`,
                  },
            color: {
                id: rest.color.id,
                description: `${rest.color.four_digit_code} - ${rest.color.name}`,
            },
            material: {
                id: rest.material.id,
                description: `${rest.material.four_digit_code} - ${rest.material.name}`,
            },
            decoration_technique: { ...rest.deco_tech },
            artwork: {
                id: rest.artwork?.id,
                description: `${rest.artwork?.id} - ${rest.artwork?.name}`,
            },
            sequence_number: `${sequence_number}`,
        };

        return nonMold;
    }

    const { id, name } = mold;

    const molded = {
        mold: { id, description: `${id} - ${name}` },
        color: { id: rest.color.id, description: `${rest.color.four_digit_code} - ${rest.color.name}` },
        material: { id: rest.material.id, description: `${rest.material.four_digit_code} - ${rest.material.name}` },
        decoration_technique: { ...rest.deco_tech },
        artwork: { id: rest.artwork?.id, description: `${rest.artwork?.id} - ${rest.artwork?.name}` },
    };

    return molded;

};

const mapObjectTo = (obj:any, updatedObj = {}) => {

    Object.keys(obj).forEach((key) => {

        const newKeys = key.split("_");

        switch (key) {
            case "decoration_technique_id":
                newKeys[0] = "decoration_technique";
                newKeys[1] = "id";
                break;
            case "decoration_technique_description":
                newKeys[0] = "decoration_technique";
                newKeys[1] = "description";
                break;

            case "sequence_number":
                newKeys[0] = "sequence_number";
                newKeys[1] = "sequence_number";
                break;

            case "mold":
                newKeys[0] = "mold";
                newKeys[1] = "id";
        }

        if (newKeys.length > 1 && updatedObj.hasOwnProperty(newKeys[0])) {
            // @ts-ignore
            updatedObj[newKeys[0]][newKeys[1]] = `${obj[key]}`;
        } else {
            // @ts-ignore
            updatedObj[newKeys[0]] = {};
            // @ts-ignore
            updatedObj[newKeys[0]][newKeys[1]] = `${obj[key]}`;
        }
    });

    return updatedObj;
};

const componentsDto = (component:any) => {
    const comp = mapObjectTo(component);

    return comp;

};

const formatDisplayComponent = (
  component:any
) => {
  const isPipPageOrModal = isPipPage || isModal;

  //@ts-ignore
  const {
      full_objects,
      color,
      material,
      nr_pieces,
      is_tps,
      type,
      sequence_number,
      ...cleanedComponent
  } = component;

  if (isPipPageOrModal && component.hasOwnProperty(full_objects)) {
      return { ...pipPageAndModalComponents(full_objects, type), nr_pieces, is_tps, type };
  }

  return {
      ...componentsDto(cleanedComponent),
      nr_pieces,
      is_tps,
      type,
      sequence_number,
  };
};

const validateIsNull = (itemsToValidate:any[]) => {
  return itemsToValidate.some(item => Predicates.isNotNullAndNotUndefinedAndNotEmpty(item)) && !!itemsToValidate[0] && itemsToValidate[0] !== "null"
};

const validatedSplitted = (description:string) =>{
  return description.split(" - ").length > 1 && description.split(" - ").length < 3
}
  return (
    <table className="table table-striped mb-0 sku-composition-components-table">
      <thead>
        <tr>
          {isModal && !isSummaryPage && <th scope="col"></th>}
          {/*<th scope="col" className="component-col">*/}
          {/*  Component Type*/}
          {/*</th>*/}
          <th scope="col" className="pcs-col">
            {componentsType === "Molded" && "Mold"}
            {componentsType !== "Molded" && "Sequence"}
          </th>
          <th scope="col" className="artwork-col">
            Mkt Mat Type
          </th>
          <th scope="col" className="material-col">
            Material
          </th>
          <th scope="col" className="mold-index-col">
            Color
          </th>
          <th scope="col" className="mold-index-col">
            Pcs./ Set.
          </th>
          <th scope="col" className="mold-index-col">
            Deco Tech
          </th>
          <th scope="col" className="mold-index-col">
            Artwork
          </th>
          <th scope="col" className="mold-index-col">
            TPS
          </th>
          <th scope="col" className="mold-index-col">
            Index
          </th>
          {    !isSummaryPage &&
                !isModal &&
                addActionHandler &&
                openEditModal &&
                handleRemoveNode && (
            <th scope="col" className="mold-index-col">
              Actions
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        <tr></tr>
        {components?.map((component: ICompositionMpnComponent) => {
            //@ts-ignore
            const { mold, material, color, ...rest } =
                formatDisplayComponent(component);

          //@ts-ignore
          const componentColorFamily = component.hasOwnProperty("color_family_name") && component?.color_family_name


          // @ts-ignore
          return (
              <tr key={component.node_id}>
                  {isModal && !isSummaryPage && (
                      <td>
                          <CompositionCheckbox
                              nodeId={component.node_id ?? -1}
                              isDisabled={shouldIncludeSku}
                              isChecked={assertComponentIsIncluded(
                                  component.type,
                                  component.node_id,
                              )}
                              checkedChangeHandler={manageComponentInclusion}
                          />
                      </td>
                  )}
                  <td>
                      {isPipPage && componentsType !== "NonMolded" ? (
                          <a
                              className="fw-bold"
                              target="_blank"
                              href={`${
                                  process.env.REACT_APP_MOLD_APP_URL
                                //@ts-ignore
                              }/ords/moldapp/product_master.prod_mold_list?moldid=${component?.mold_id ?? component?.mold}&p_prodid=${skuId}`}
                          >
                              <span>{formatMoldLabel(null, mold?.description)}</span>
                          </a>
                      ) : (
                          <span>
                                  {//@ts-ignore
                                    formatMoldLabel(Predicates.isNotNullAndNotUndefinedAndNotEmpty(rest?.sequence_number) ? rest?.sequence_number: mold?.id, mold?.description)
                                  }
                          </span>
                      )}
                  </td>
                  <td>{"-"}</td>
                  <td>
                      {validateIsNull([material?.id, material?.description]) && formatCodeLabel(material?.id, material?.description)}
                  </td>
                  <td>
                      <Tooltip
                          id="color-family-tooltip"
                          className="tooltip-text-box"
                          place="top"
                          noArrow={true}
                      />
                      <span
                          className="tooltip-span p-0 ml-0"
                          data-tooltip-id="color-family-tooltip"
                          data-tooltip-html={
                              // @ts-ignore
                              componentColorFamily
                                  ? // @ts-ignore
                                    componentColorFamily
                                  : null
                          }
                      >
                          {validateIsNull([color?.id, color?.description]) ? formatCodeLabel(color?.id.padStart(4, "0"), color?.description) : "-"}
                      </span>
                  </td>
                  <td>{component.nr_pieces}</td>

                  <td>
                      {
                          //@ts-ignore
                           rest?.decoration_technique?.id > 0 && validateIsNull([rest?.decoration_technique?.id, rest?.decoration_technique?.description]) ? formatCodeLabel(rest?.decoration_technique?.id.padStart(4, "0"), rest?.decoration_technique?.description) : "-"}
                  </td>

                  <td>
                      {
                          //@ts-ignore
                            rest?.artwork?.id > 0 && validateIsNull([rest?.artwork?.id, rest?.artwork?.description]) ? formatCodeLabel(rest?.artwork?.id.padStart(5, "0"), rest?.artwork?.description) : "-"}
                  </td>

                  <td>{component.is_tps ? "Y" : "N"}</td>
                  <td>{component?.mold_index}</td>

                  {
                      //@ts-ignore
                      !isSummaryPage &&
                          !isModal &&
                          addActionHandler &&
                          openEditModal &&
                          handleRemoveNode && (
                              <td>
                                  <TreeActionsGroup
                                      node={component}
                                      isMainPage={!isModal}
                                      compositionType="component"
                                      addActionHandler={() => {}}
                                      editActionHandler={() =>
                                          //@ts-ignore
                                          openEditModal("component", component)
                                      }
                                      removeActionHandler={() =>
                                          handleRemoveNode(
                                              //@ts-ignore
                                              component,
                                              "component",
                                          )
                                      }
                                      isMandatory={
                                          component.isMandatory !== "Y"
                                      }
                                  />
                              </td>
                          )
                  }
              </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ComponentsTable;
